export type StatusPillClasses = { pill: string; dot: string; label: string };

export function normalizeRunStatus(v: any): string {
  return String(v ?? '').trim().toUpperCase();
}

export function toStatusLabel(statusRaw: any, fallback: string = 'PENDING'): string {
  const s = normalizeRunStatus(statusRaw);
  if (s) return s;
  const fb = normalizeRunStatus(fallback);
  return fb || 'PENDING';
}

export function isRunningStatus(statusRaw: any): boolean {
  const s = normalizeRunStatus(statusRaw);
  return s === 'RUNNING' || s === 'IN_PROGRESS' || s === 'STARTED';
}

export function getStatusPillClasses(statusRaw: any): StatusPillClasses {
  const status = normalizeRunStatus(statusRaw);
  if (status === 'DISCARDED' || status === 'SKIPPED' || status === 'DISABLED') {
    return {
      pill: 'border-neutral-950 pac-glass-subtle text-neutral-600 italic',
      dot: 'pac-glass-subtle',
      label: status || 'DISCARDED',
    };
  }
  if (status === 'SUCCEEDED' || status === 'DONE') {
    return {
      pill: 'border-emerald-800/60 bg-emerald-950/40 text-emerald-200',
      dot: 'bg-emerald-400',
      label: status || 'SUCCEEDED',
    };
  }
  if (status === 'FAILED' || status === 'ERROR') {
    return {
      pill: 'border-rose-800/60 bg-rose-950/40 text-rose-200',
      dot: 'bg-rose-400',
      label: status || 'FAILED',
    };
  }
  if (isRunningStatus(status)) {
    return {
      pill: 'border-amber-800/60 bg-amber-950/30 text-amber-200',
      dot: 'bg-amber-400',
      label: status || 'RUNNING',
    };
  }
  if (status === 'READY') {
    return {
      pill: 'border-sky-800/60 bg-sky-950/30 text-sky-200',
      dot: 'bg-sky-400',
      label: status,
    };
  }
  return {
    pill: 'border-neutral-700 pac-glass text-neutral-200',
    dot: 'bg-neutral-400',
    label: status || 'PENDING',
  };
}

export function getStatusTextClass(statusRaw: any): string {
  const status = normalizeRunStatus(statusRaw);
  if (status === 'DISCARDED' || status === 'SKIPPED' || status === 'DISABLED') return 'text-neutral-600 italic';
  if (status === 'SUCCEEDED' || status === 'DONE') return 'text-emerald-300';
  if (status === 'FAILED' || status === 'ERROR') return 'text-rose-300';
  if (isRunningStatus(status)) return 'text-amber-300';
  if (status === 'READY') return 'text-sky-300';
  return 'text-neutral-300';
}

// Keep the “running” animation tokens DRY across summary pills and graph step boxes.
export const vumeterBorderClass =
  " before:content-[''] before:absolute before:pointer-events-none before:inset-0 before:rounded before:border-2 before:border-emerald-400/40 before:motion-safe:animate-[pac-vumeter-border_1100ms_ease-in-out_infinite] before:motion-reduce:animate-none before:z-0";

export const vumeterTextClass =
  ' pac-vumeter-text text-transparent bg-clip-text bg-gradient-to-t from-emerald-950 via-emerald-400 to-emerald-200';
